import { ComponentProps } from 'react';

type Statuses = Record<string, { color: string; pulse?: boolean }>;

interface StatusIndicatorProps<T extends Statuses> {
  status: keyof T;
  statuses: T;
}

const radius = 4;
const strokeWidth = 2;
export function StatusIndicator<T extends Statuses>({
  status,
  statuses,
  ...props
}: StatusIndicatorProps<T> & ComponentProps<'div'>) {
  // function getColor(s: Status) {
  //   switch (s) {
  //     case 'yellow':
  //       return '#ffc107';
  //     case 'green':
  //       return '#28a745';
  //     default:
  //       return '#dc3545';
  //   }
  // }
  // const stroke = getColor(status);

  const currentStatus = statuses[status];
  const stroke = currentStatus?.color || 'gray';

  const diameter = radius * 2 + strokeWidth;

  return (
    <div
      className="status-indicator"
      title={status as string}
      style={{ width: `${diameter}px`, height: `${diameter}px` }}
      {...props}
    >
      <svg
        className={`duration-75 ${currentStatus?.pulse && 'animate-pulse'}`}
        // className={`${status === 'yellow' && 'animate-pulse'} duration-75 `}
        style={{ width: `${diameter}px`, height: `${diameter}px` }}
        width={diameter}
        height={diameter}
      >
        <circle
          cx={diameter / 2}
          cy={diameter / 2}
          r={radius}
          stroke={stroke}
          strokeWidth={strokeWidth}
          fill={'none'}
        />
      </svg>
    </div>
  );
}
